import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useRef } from 'react';
import { buildBreadcrumbsConfigs, buildSizeMap } from '../../utils';
import { Collapse } from '../Collapse';
import { Separator } from '../Separator';
import { Wrapper } from '../Wrapper';
import { useItemModesRender } from './hooks';
export const HiddenChain = memo(function HiddenChain({ size, separator, items, onConfigsBuilt, firstItemIconOnly = false, lastEmpty = false, }) {
    const containerRef = useRef(null);
    const itemsRef = useRef(items);
    itemsRef.current = items;
    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            const observer = new ResizeObserver(([{ target }]) => {
                const sizeMap = buildSizeMap(target);
                if (sizeMap) {
                    onConfigsBuilt(buildBreadcrumbsConfigs(itemsRef.current, sizeMap, lastEmpty));
                }
            });
            observer.observe(container);
            return () => {
                observer.disconnect();
            };
        }
    }, [items, lastEmpty, onConfigsBuilt]);
    const renderItemModes = useItemModesRender({ firstItemIconOnly });
    return (_jsxs(Wrapper, { size: size, hidden: true, ref: containerRef, separator: separator, "data-test-id": 'hidden-wrapper', children: [_jsx(Separator, {}), _jsx(Collapse, { currentConfig: [] }), items.map(renderItemModes)] }));
});
